import React from 'react';

const SUITS = ['♠', '♥', '♦', '♣'];

const placements = [
  { top: '3%',  left: '6%',   size: 44, rot: -8,  delay: '0s',  duration: '18s', driftX: '15px', floatY: '20px' },
  { top: '5%',  left: '85%',  size: 38, rot: 12,  delay: '2s',  duration: '16s', driftX: '-12px', floatY: '18px' },
  { top: '12%', left: '72%',  size: 50, rot: -15, delay: '4s',  duration: '20s', driftX: '18px', floatY: '22px' },
  { top: '16%', left: '8%',   size: 34, rot: 6,   delay: '1s',  duration: '14s', driftX: '-10px', floatY: '16px' },
  { top: '22%', left: '90%',  size: 42, rot: -4,  delay: '3s',  duration: '17s', driftX: '14px', floatY: '20px' },
  { top: '28%', left: '4%',   size: 46, rot: 18,  delay: '5s',  duration: '19s', driftX: '-16px', floatY: '24px' },
  { top: '33%', left: '80%',  size: 36, rot: -10, delay: '2s',  duration: '15s', driftX: '12px', floatY: '18px' },
  { top: '40%', left: '10%',  size: 40, rot: 8,   delay: '4s',  duration: '18s', driftX: '-14px', floatY: '20px' },
  { top: '45%', left: '88%',  size: 48, rot: -6,  delay: '1s',  duration: '16s', driftX: '10px', floatY: '16px' },
  { top: '52%', left: '5%',   size: 34, rot: 14,  delay: '3s',  duration: '20s', driftX: '-12px', floatY: '18px' },
  { top: '56%', left: '82%',  size: 44, rot: -12, delay: '0s',  duration: '17s', driftX: '16px', floatY: '22px' },
  { top: '63%', left: '7%',   size: 38, rot: 10,  delay: '2s',  duration: '15s', driftX: '-10px', floatY: '16px' },
  { top: '68%', left: '92%',  size: 42, rot: -8,  delay: '4s',  duration: '19s', driftX: '14px', floatY: '20px' },
  { top: '75%', left: '3%',   size: 46, rot: 16,  delay: '1s',  duration: '18s', driftX: '-16px', floatY: '24px' },
  { top: '80%', left: '86%',  size: 36, rot: -14, delay: '3s',  duration: '16s', driftX: '12px', floatY: '18px' },
  { top: '88%', left: '9%',   size: 40, rot: 6,   delay: '5s',  duration: '14s', driftX: '-14px', floatY: '20px' },
  { top: '93%', left: '78%',  size: 48, rot: -4,  delay: '2s',  duration: '20s', driftX: '10px', floatY: '16px' },
  { top: '97%', left: '50%',  size: 34, rot: 12,  delay: '0s',  duration: '17s', driftX: '-12px', floatY: '18px' },
];

const GlobalSuits = () => (
  <div className="global-suits" aria-hidden="true">
    {placements.map((p, i) => (
      <span
        key={i}
        className={`global-suit ${SUITS[i % 4] === '♥' || SUITS[i % 4] === '♦' ? 'red' : ''}`}
        style={{
          top: p.top,
          left: p.left,
          fontSize: `${p.size}px`,
          '--rot': `${p.rot}deg`,
          '--delay': p.delay,
          '--duration': p.duration,
          '--driftX': p.driftX,
          '--floatY': p.floatY,
        }}
      >
        {SUITS[i % 4]}
      </span>
    ))}
  </div>
);

export default GlobalSuits;
